import { apiCall } from '../apiHelpers';

// Posts functions
export const getPosts = async (clubId, options = {}) => {
  const params = new URLSearchParams({ clubId: clubId.toString() });
  
  if (options.limit) {
    params.append('limit', options.limit.toString());
  }

  if (options.includeActivity !== undefined) {
    params.append('includeActivity', options.includeActivity ? 'true' : 'false');
  }
  
  if (options.beforeId) {
    params.append('beforeId', options.beforeId.toString());
  }

  if (options.userId) {
    params.append('userId', options.userId.toString());
  }

  if (options.cacheBust) {
    params.append('_cb', String(options.cacheBust));
  }

  const result = await apiCall(
    `/v1/posts?${params}`,
    options.noStore ? { cache: 'no-store' } : undefined,
  );
  return result;
};

export const getPost = async (clubId, postId, options = {}) => {
  const params = new URLSearchParams({ clubId: clubId.toString() });
  const post = await apiCall(
    `/v1/posts/${postId}?${params}`,
    options.noStore ? { cache: 'no-store' } : undefined,
  );
  return post;
};

export const createPost = async (clubId, post) => {
  const params = new URLSearchParams({ clubId: clubId.toString() });
  const result = await apiCall(`/v1/posts?${params}`, {
    method: 'POST',
    body: JSON.stringify(post),
  });
  return result;
};

export const updatePost = async (clubId, postId, userId, data) => {
  const params = new URLSearchParams({
    clubId: clubId.toString(),
    userId,
  });
  const result = await apiCall(`/v1/posts/${postId}?${params}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
  return result;
};

export const deletePost = async (clubId, postId, userId) => {
  const params = new URLSearchParams({
    clubId: clubId.toString(),
    userId,
  });
  const result = await apiCall(`/v1/posts/${postId}?${params}`, {
    method: 'DELETE',
  });
  return result;
};

// Alias for backward compatibility
export const addPost = createPost;

export const addReaction = async (clubId, postId, emoji, userId) => {
  const params = new URLSearchParams({ clubId: clubId.toString() });
  const result = await apiCall(`/v1/posts/${postId}/reactions?${params}`, {
    method: 'POST',
    body: JSON.stringify({ emoji, userId }),
  });
  return result;
};

export const removeReaction = async (clubId, postId, emoji, userId) => {
  const params = new URLSearchParams({ 
    clubId: clubId.toString(),
    userId: userId,
  });
  const encodedEmoji = encodeURIComponent(emoji);
  await apiCall(`/v1/posts/${postId}/reactions/${encodedEmoji}?${params}`, {
    method: 'DELETE',
  });
};

export const getReactions = async (clubId, postId) => {
  const params = new URLSearchParams({ clubId: clubId.toString() });
  const reactions = await apiCall(`/v1/posts/${postId}/reactions?${params}`);
  return reactions;
};

